import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FaSearch } from 'react-icons/fa';

const Searchbar = () => {
  const [searchResult, setSearchResult] = useState([]);
  const [value, setValue] = useState([]);
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    axios
      .get(
        `https://api.themoviedb.org/3/search/company?api_key=0bdaffe7e2eab547e56a8fb25f90ff20&query=${value}`
      )
      .then(function (response) {
        setSearchResult(response?.data?.results);
        // console.log(response?.data?.results);
      });
  }, [value]);

  const searchMoive = (e) => {
    setValue(e);
    // console.log(e);
  };

  return (
    <div className='flex flex-row items-center gap-5 sm:justify-end  '>
      <div className='relative'>
        <input
          type='text'
          className={`border focus:outline-none border-gray-300 rounded-md py-2 px-4 pr-12 transition-all duration-500 h-10 ${
            expanded ? 'md:w-[32rem] w-[20rem]' : 'w-16'
          }`}
          placeholder='Search'
          onChange={(e) => searchMoive(e.target.value)}
        />
        <FaSearch
          className='absolute px-2 py-2 right-0 top-0 bottom-0 flex items-center justify-center bg-gray-200 rounded-r-md  w-20 h-10 transition-all duration-300'
          color='black'
          size='30px'
          // onMouseOver={{ cursor: 'pointer' }}
          style={{ cursor: 'pointer' }}
          onClick={toggleExpand}
        />
      </div>

      {searchResult.length > 0 && value && (
        <div
          style={{
            backgroundColor: 'black',
            maxHeight: '200px',
            overflowY: 'auto',
            display: 'block',
            zIndex: '500',
            position: 'absolute',
            marginTop: '240px',
          }}
          className='p-2  md:w-[32rem] w-[20rem]'
        >
          {searchResult.map((item, i) => {
            return (
              <p
                key={item?.id}
                className='p-2 text-white '
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  // setShowTerritoryList(false);
                  // handleGetRouteList(item);
                }}
              >
                {item.name}
              </p>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Searchbar;
